import React from 'react';
import {colors} from "../styles/colors";
import {translate} from 'react-i18next';
import ArrowBack from 'material-ui-icons/ArrowBack';
import {navigationBack} from "../navigation/NavigationActions";
import {connect} from "react-redux";
import {
    FacebookShareButton,
    WhatsappShareButton,
    EmailShareButton, FacebookIcon, WhatsappIcon, EmailIcon,
} from 'react-share';
import {ListItem} from "material-ui";
import {getUserSync} from "../utils/auth";
import Link from 'material-ui-icons/Link';
import {CopyToClipboard} from 'react-copy-to-clipboard';

class InviteScreen extends React.PureComponent {


    constructor(props) {
        super(props);
        this.state = {
            copied: false,
        };
    }


    getShareUrl() {
        return 'https://toplife.zone/?inv=' + getUserSync()._id
    }

    render() {
        const {t} = this.props;

        return (
            <div >
                <div className="toolbar">
                    <div className="back-arrow" onClick={() => this.props.goBack()}>
                        <ArrowBack />
                    </div>

                    <h2 style={styles.flex}>{t('invite:title')}</h2>

                </div>
                <div style={styles.shareContainer}>
                    <h1 style={styles.flex}><span
                        style={styles.new}>{t('invite:new')}</span>{t('invite:descriptionTitle')}</h1>
                    <p>{t('invite:description')}<b>{t('invite:friends_amount')}</b></p>

                    <div style={styles.share}>

                        <ListItem button style={styles.smListButton}>
                            <WhatsappShareButton url={this.getShareUrl()} style={styles.smLayout}>
                                <WhatsappIcon size={38} round={true}/>
                                <p style={styles.smText}>{t('invite:shareWhatsApp')}</p>
                            </WhatsappShareButton>
                        </ListItem>

                        <ListItem button style={styles.smListButton}>
                            <FacebookShareButton url={this.getShareUrl()} style={styles.smLayout}>
                                <FacebookIcon size={38} round={true}/>
                                <p style={styles.smText}>{t('invite:shareFacebook')}</p>
                            </FacebookShareButton>
                        </ListItem>

                        <ListItem button style={styles.smListButton}>
                            <EmailShareButton url={this.getShareUrl()} style={styles.smLayout}>
                                <EmailIcon size={38} round={true}/>
                                <p style={styles.smText}>{t('invite:shareEmail')}</p>
                            </EmailShareButton>
                        </ListItem>


                    </div>
                    <div style={styles.highlight}>
                        <ListItem button style={styles.smListButton}>

                            <CopyToClipboard text={this.getShareUrl()}
                                             onCopy={() => this.setState({copied: true})}>
                                <div style={styles.smLayout}>
                                    <Link />
                                    <p style={styles.smText}>{t('invite:shareLink')}</p>
                                </div>
                            </CopyToClipboard>
                        </ListItem>
                    </div>

                    {this.state.copied ? <span style={{color: 'red'}}>{t('common:linkCopied')}</span> : null}

                </div>
            </div>
        );
    }

}


const styles = ({
    shareContainer: {
        maxWidth: 512,
        margin: '0 auto',
        paddingTop: 72,
        paddingRight: 16,
        paddingLeft: 16
    },
    flex: {
        flex: 1,
    },
    new: {
        backgroundColor: colors.red,
        color: colors.white,
        marginRight: 8,
        paddingLeft: 4,
        paddingRight: 4,
    },
    share: {
        marginTop: 16,
        marginBottom: 16,
    },
    highlight: {
        flex: 1,
        display: 'flex',
        padding: 16,
        backgroundColor: colors.white,
        boxShadow: `0 1px 3px 0 rgba(41,70,97,.2)`,
        borderRadius: 3,
    },
    icon: {
        marginRight: 16,
    },
    smLayout: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        outline: 'none'
    },
    smText: {
        paddingLeft: 16
    },
    smListButton: {
        paddingLeft: 16
    },
    smSkip: {
        paddingTop: 16,
        paddingBottom: 16,
        textDecoration: 'underline',
        cursor: 'pointer',
        textAlign: 'center',
        color: colors.text_light
    },
    hideShareLayout: {
        paddingTop: 32,
    }
});

/*
 const mapStateToProps = (state) => {
 return {
 user: state.auth.user,
 loadingLevelFailed: state.loadingLevelFailed,
 isLoading: state.levelLoading
 };
 };*/

const mapDispatchToProps = (dispatch) => {
    return {
        goBack: () => dispatch(navigationBack())
    };
};

export default connect(null, mapDispatchToProps)(translate(['invite', 'common'])(InviteScreen));


// WEBPACK FOOTER //
// ./src/invite/InviteScreen.js